/** @format */
import angular from 'angular';
export const studentSharedModule = 'student.shared';
(function () {
  angular.module('student.shared', []);
})();